/*
  Content Grid
*/

class ContentGrid extends HTMLElement {
  connectedCallback() {
    this.querySelector("grid-nav").addEventListener("click", (e) => {
      if (e.target.tagName === "BUTTON") {
        const type = e.target.dataset.filter;

        Array.from(this.querySelectorAll("button")).forEach((button) => {
          button.classList.remove("underline");
        });

        e.target.classList.add("underline");

        Array.from(this.querySelectorAll(`[data-type]`)).forEach((el) => {
          if (type === "all") {
            el.classList.remove("hidden");
          } else {
            if (el.dataset.type !== type) {
              el.classList.add("hidden");
            } else {
              el.classList.remove("hidden");
            }
          }
        });
      }
    });
  }
}

customElements.define("content-grid", ContentGrid);

/*
Archive Flyout
*/

class ArchiveFlyout extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.querySelector("button")) {
      console.warn("Archive Flyout component should have a button as a child!");
    }

    this.addEventListener("click", (e) => {
      const flyout = document.querySelector("site-flyout");
      const handle = e.target.closest("button").dataset.handle;

      flyout.classList.add("archive");
      flyout.showLoader();
      flyout.open();

      if (flyout) {
        fetch(`${window.location.origin}/blogs/${handle}?sections=main-archive`)
          .then((response) => response.json())
          .then((response) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(
              response["main-archive"],
              "text/html"
            );
            const h1 = doc.querySelector("h1");
            const title = h1 ? h1.innerHTML : "";
            const cont = doc.querySelector(".pt-14");
            const flyoutH1 = flyout.querySelector("h1");

            flyoutH1.innerHTML = title;

            cont.classList.remove("pt-14");

            h1.remove();
            flyout.render(doc.documentElement.outerHTML);
            flyout.hideLoader();
          });
      }
    });
  }
}

customElements.define("archive-flyout", ArchiveFlyout);

/*
Intro Anim
*/

class IntroAnim extends HTMLElement {
  constructor() {
    super();
    this.words = null;
    this.positions = [];
    this.scrolled = false;
  }

  connectedCallback() {
    this.words = Array.from(this.querySelectorAll("p"));
    const mq = window.matchMedia("(min-width: 1024px)");
    const handleResize = () => {
      if (mq.matches) {
        this.calculatePositions();
        this.classList.remove("opacity-0");
        this.handleScroll();

        window.addEventListener("scroll", () => {
          this.calculatePositions();
          this.scrolled = true;
          this.handleScroll();
        });
        window.addEventListener("resize", () => {
          this.calculatePositions();
          this.handleScroll();
        });
      }
    };
    handleResize();
    mq.addListener(handleResize);
  }

  handleScroll() {
    const y = window.scrollY || 0;
    const activePos = Object.keys(this.positions).filter((key) => key <= y);
    const lastItem = activePos[activePos.length - 1];
    const finalPositions = this.positions[lastItem];

    this.words.forEach((word, i) => {
      const match = finalPositions[i];
      word.style.opacity = match.opacity;
      word.style.transform = match.transform;
      word.style.transition = this.scrolled
        ? "all .5s ease"
        : "opacity .5s ease";
    });

    const header = document.querySelector(".site-header");
    const animEndText = document.querySelector(".anim-end-text");
    if (y >= window.innerHeight * 1.6) {
      header.classList.remove("lg:opacity-0");
      animEndText.classList.add("active");
      this.classList.add("inactive");
    } else {
      header.classList.add("lg:opacity-0");
      animEndText.classList.remove("active");
      this.classList.remove("inactive");
    }

    const scrollForMore = document.querySelector(".scroll-for-more");
    if (y > 20) {
      scrollForMore.style.opacity = 0;
    } else {
      scrollForMore.style.opacity = 1;
    }
  }

  calculatePositions() {
    const wordGap = 9;
    const containerWidth = this.getBoundingClientRect().width;
    const totalScroll = window.innerHeight * 1.6;
    const animPoint = totalScroll / this.words.length + 1;
    const anims = this.words.map((word, i) => i * animPoint);
    const positions = anims.reduce((acc, anim, i) => {
      const visibleCount = this.words.filter((word, j) => j <= i).length - 1;
      const space = (visibleCount - 1) * wordGap;
      const visibleWidth =
        this.words.reduce((bcc, word, j) => {
          const wordWidth = word.getBoundingClientRect().width;
          return j <= visibleCount ? bcc + wordWidth : bcc;
        }, 0) + space;

      const startingPoint = containerWidth / 2 - visibleWidth / 2 + wordGap / 2;
      const pos = this.words.map((word, j) => {
        const space = (j - 1) * wordGap;
        const before =
          this.words.reduce((bcc, word, k) => {
            const wordWidth = word.getBoundingClientRect().width;
            return k <= j - 1 ? bcc + wordWidth : bcc;
          }, 0) + space;
        const width = word.getBoundingClientRect().width;
        return {
          opacity: j <= i ? 1 : 0,
          transform: `translateX(${Math.round(startingPoint + before)}px)`,
        };
      });
      return {
        ...acc,
        [anim]: pos,
      };
    }, {});
    this.positions = positions;
  }
}

customElements.define("intro-anim", IntroAnim);
